'use client';

import React, { useEffect, useState } from 'react';
import {
  HeroSection,
  VideoSection,
  // CarouselSection,
  DesignSection,
  ImageSection,
  EngineeringSection,
  BatterySection,
  ChargerIntroSection,
  ChargerFeaturesSection,
  UltraSnapSection,
  AppSection,
  FeaturesSection,
  JadeAISection,
  ImageMarqueeSection,
  ClosingSection,
} from 'components/ring-pro';
import { jetbrainsMono, twkEverett } from 'utils/fonts';
import { useRegionLocale } from 'contexts/RegionLocaleContext';
import {
  fetchTierCampaignData,
  getRingProBasePrice,
} from 'content/products/ring-pro/tierPricing';
import { CurrencySymbol } from 'components/shared/CurrencySymbol';
import { Currency } from 'utils/Currency';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import type { TierCampaignData } from 'components/ring-pro/utils/types';

const RingPro = () => {
  const { store: regionStore, currency: regionCurrency } =
    useRegionLocale();

  const [tierCampaign, setTierCampaign] = useState<TierCampaignData | null>(
    null,
  );
  useEffect(() => {
    fetchTierCampaignData().then((data) => {
      if (data?.campaign_active) setTierCampaign(data);
    });
  }, []);

  const store = regionStore ?? ShopifyStore.ROW;
  const ringProCurrency = (regionCurrency as Currency) || Currency.usd;
  const ringProBasePrice =
    getRingProBasePrice(store as ShopifyStore, ringProCurrency) ?? 0;
  const ringProCurrencySymbol = CurrencySymbol[ringProCurrency] ?? '$';

  return (
    <>
      <main className={`${jetbrainsMono.variable} ${twkEverett.variable}`}>
        <HeroSection
          tierCampaign={tierCampaign}
          basePrice={ringProBasePrice}
          currencySymbol={ringProCurrencySymbol}
          store={store as string}
        />
        {/* <CarouselSection /> */}
        <BatterySection />
        <ChargerIntroSection />
        <ChargerFeaturesSection />
        <UltraSnapSection />
        <JadeAISection />
        <DesignSection />
        <ImageSection />
        <EngineeringSection />
        {/* <ScrollSequenceSection /> */}
        {/* <CaseSection /> */}
        <VideoSection />
        <AppSection />
        <FeaturesSection />
        <ImageMarqueeSection />
        <ClosingSection />
      </main>
    </>
  );
};

export default RingPro;
